import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  other: {
    paddingBottom: theme.spacing(8),
  },
  img: {
    margin: '0 auto',
    display: 'block',
    maxWidth: '100%',
  },
  backButton: {
    position: 'absolute',
    top: theme.spacing(4),
    left: '-32px',
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(1),
      left: '-16px',
    },
    '&:hover': {
      '& svg': {
        transform: 'translateX(-4px)',
      },
    },
  },
}))

export default useStyles
